import { get as getCookie } from 'es-cookie';

function getESourceId() {
    const mktTrackValue = getCookie('LT_MKT_TRACK');
    if (!mktTrackValue) {
        return null;
    }
    const searchParams = new window.URLSearchParams(mktTrackValue);
    const esourceid = parseInt(searchParams.get('esourceid'));
    return esourceid;
}

function parseInt(value: string | null): number | null {
    if (!value) {
        return null;
    }
    const parseInt = Number.parseInt || (<any>window).parseInt; //fall back to window for IE
    const isNaN = Number.isNaN || (<any>window).isNaN; //fall back to window for IE

    const dma = parseInt(value, 10);
    if (isNaN(dma)) {
        return null;
    }
    return dma;
}

function formatCurrency(value: number | null, maxDecimals: number | null, lowerCase: boolean): string | null {
    if (!value) {
        return null;
    }

    var returnValue = value.toString();
    
    if (value >= 1000) {
        if (lowerCase)
            var suffixes = ['', '', 'k', 'm', 'b'];
        else
            var suffixes = ['', '', 'K', 'MM', 'B'];

        var suffixIndex = Math.ceil( (value + '').length/3 );
        var shortValue = 0;
        var dotlessShortValue = '0';

        for (var precision = 4; precision >= 1; precision--) {
            shortValue = parseFloat( (suffixIndex != 0 ? (value / Math.pow(1000,suffixIndex-1) ) : value).toPrecision(precision));
            dotlessShortValue = (shortValue + '').replace(/[^a-zA-Z 0-9]+/g,'');
            if (dotlessShortValue.length <= 4) { break; }
        }
        
        if (!maxDecimals) {    // Default to Bank Page Health Section special condition
            if (shortValue % 1 != 0) {
                if (shortValue >= 100)
                    returnValue = parseFloat(shortValue.toFixed(2)) + suffixes[suffixIndex];
                else
                    returnValue = shortValue.toFixed(2) + suffixes[suffixIndex];
            }
            else {
                returnValue = shortValue + '.0' + suffixes[suffixIndex];
            }
        }
        else {
            returnValue = parseFloat(shortValue.toFixed(maxDecimals)) + suffixes[suffixIndex];
        }
    }
    return '$' + returnValue;
}

function JSONtoQuerystring(obj: any) :string {
    return Object.keys(obj).map(key => key + '=' + obj[key]).join('&');
}
export default{
    getESourceId,
    formatCurrency,
    JSONtoQuerystring
}